import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledProfileFoldout = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  
  .ProfileFoldout {
    &-toolbar {
      gap: ${props => props.theme.layout('1sp')};
      padding: 0 ${props => props.theme.spacing(3)};
      min-height: ${props => props.theme.layout(61)};
      border-bottom: 1px solid ${props => props.theme.property('palette.divider')};
      &-title {
        flex-grow: 1;
        overflow: hidden;
        
        > * {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }

  &.ProfileFoldout {
    &:has(.SectionPanel-tabs) {
      .ProfileFoldout {
        &-toolbar {
          margin-bottom: -${props => props.theme.layout('0.5sp')};
          border-bottom: unset;
        }
      }
    }

    .SectionPanel {
      padding-top: 0;

      &-tabs {
        padding: 0 ${props => props.theme.spacing(3)} 0 ${props => props.theme.spacing(3)};
      }

      &-panel {
        overflow-y: auto;
      }
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .ProfileFoldout {
      &-toolbar {
        padding: 0 ${props => props.theme.spacing(2)};
      }
    }

    &.ProfileFoldout {
      .SectionPanel {
        &-tabs {
          padding: 0 ${props => props.theme.spacing(2)} 0 ${props => props.theme.spacing(2)};
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledProfileFoldout.propTypes = {
  theme: PropTypes.object
};

export default StyledProfileFoldout;
